import {useQuery, useQueryClient} from "@tanstack/react-query";
import {useCallback} from "react";
import {ConfEnv} from "../../config/config";
import {getUserWalletService} from "../../services/wallet/getUserWallet";
import {useAuthStore} from "../../store/useAuth.store";

const useGetUserWallet = staleTime => {
  const query = useQueryClient();
  const authStatus = useAuthStore(state => state.authStatus);
  const {
    data: response,
    isError,
    isLoading,
    isSuccess,
    refetch,
    error,
  } = useQuery({
    queryKey: ["userWallet"],
    queryFn: getUserWalletService,
    staleTime: staleTime ?? 5 * (60 * 1000), // 5 mins,
    select: res => res?.data?.data,
    enabled: authStatus === "authenticated",
  });

  const accounts = response?.accounts || [];
  const balance = accounts.find(account => account.currency === ConfEnv.DEFAULT_CURRENCY);

  // Get account by currency
  const getAccountByCurrency = useCallback(
    currencyCode => {
      return accounts.find(account => account.currency === currencyCode);
    },
    [accounts]
  );

  const invalidateQuery = useCallback(() => {
    query.invalidateQueries({queryKey: ["userWallet"]});
  }, [query]);

  const balanceFormated = useCallback(() => {
    return balance?.formattedBalance || "Bs.0,00";
  }, [balance]);

  return {
    data: response,
    balance,
    accounts,
    getAccountByCurrency,
    isError,
    isLoading,
    refetch,
    isSuccess,
    error,
    balanceFormated,
    invalidateQuery,
  };
};

export default useGetUserWallet;
